import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Radio, IconButton} from '@material-ui/core';
import {ArrowBackIos} from '@material-ui/icons';
import {
    queryShipToBySupplyCenterList,
    getTransportMethodList,
    saveStApplyChange,
} from 'Actions/stManagement';
import {openNotification} from 'Actions/notification';
import BasicButton from 'Components/common/BasicButton';
import Select from 'Components/common/Select';
import BasicTextArea from 'Components/common/BasicTextArea';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';
import {loadLanguage} from 'Utils/jwtUtil';

class StApplyChange extends Component {
    state = {
        shipTo: '',
        shipToList: [],
        allShipToList: [],
        loading: false,
        description: '',
        subject: '',
        scList: [],
        stObj: {},
        supplyCenterDataList: [],
        applySupplyCenterId: '',
        transportMethodList: [],
        transportMethodId: '',
        isSave: false,
        remarkNum: 0,
    };

    componentWillMount() {
        const stItem = this.props.location.state.stItem;

        if (stItem) {
            this.getApplySupplyCenterList(stItem);
            this.getTransportMethodList(stItem);
        }
        this.setState({
            stObj: stItem,
        });
    }

    componentDidUpdate() {
        let currentMsg = this.props.msg;
        if (
            typeof currentMsg !== 'undefined' &&
            currentMsg &&
            currentMsg === '网络异常，请检查您的网络'
        ) {
            this.setState({isSave: false});
        }
    }

    getApplySupplyCenterList = (stItem) => {
        this.props.queryShipToBySupplyCenterList(stItem.shipTo).then((res) => {
            if (res && res.status === 'success' && res.data.length > 0) {
                let supplyCenterArry = [];

                res.data.forEach((spItem, spIndex) => {
                    supplyCenterArry.push({
                        id: spItem.key,
                        name: spItem.value,
                    });
                });

                this.setState({
                    supplyCenterDataList: supplyCenterArry,
                    applySupplyCenterId: stItem.actualCoveredSiteNum
                        ? stItem.actualCoveredSiteNum
                        : '',
                });
            }
        });
    };

    getTransportMethodList = (stItem) => {
        this.props.getTransportMethodList().then((res) => {
            if (res && res.status === 'success' && res.data.length > 0) {
                let transportMethodArry = [];
                res.data.forEach(
                    (transportMethodItem, transportMethodIndex) => {
                        if (transportMethodItem.key !== 'N') {
                            transportMethodArry.push({
                                id: transportMethodItem.key,
                                name: transportMethodItem.value,
                            });
                        }
                    },
                );

                this.setState({
                    transportMethodList: transportMethodArry,
                    transportMethodId: stItem.actualTransportMethod
                        ? stItem.actualTransportMethod
                        : '',
                });
            }
        });
    };

    handleTextArea = (name, value) => {
        if (value && value.length > 0) {
            let num = value && value.length;
            if (num >= 200) {
                num = 200;
            }

            this.setState({
                remarkNum: num,
                description: value,
            });
        }
    };

    clearInput = () => {
        this.setState({
            remarkNum: 0,
            description: '',
        });
    };

    confirmApply = () => {
        this.setState({loading: true, isSave: true});
        const {stObj, applySupplyCenterId, transportMethodId, description} =
            this.state;

        const params = {};
        params.shipTo = stObj.shipTo;
        params.stAlphaName = stObj.stAlphaName;
        params.stAddress = stObj.stAddress;
        if (stObj.actualCoveredSiteNum) {
            if (!applySupplyCenterId) {
                this.setState({isSave: false});
                this.props.openNotification(
                    T('st_management_apply_sp_is_not_null'),
                    'danger',
                );
            } else if (!transportMethodId) {
                this.setState({isSave: false});
                this.props.openNotification(
                    T('st_management_transation_method_is_not_null'),
                    'danger',
                );
            } else if (!description) {
                this.setState({isSave: false});
                this.props.openNotification(
                    T('st_management_apply_reason_is_not_null'),
                    'danger',
                );
            } else if (description.length > 200) {
                this.setState({isSave: false});
                this.props.openNotification(
                    T('st_management_apply_reason_length_not_more_than_200'),
                    'danger',
                );
            } else {
                params.stActualCoveredSiteNum = stObj.actualCoveredSiteNum;
                params.applyActualCoveredSiteNum = applySupplyCenterId;
                params.stActualTransportMethod = 'N';
                params.applyActualTransportMethod = transportMethodId;
                params.reasons = description;
                this.saveApplyChange(params);
            }
        } else {
            params.stActualCoveredSiteNum = '';
            params.applyActualCoveredSiteNum = '';
            params.stActualTransportMethod = '';
            params.applyActualTransportMethod = '';
            params.reasons = description;
            if (!description) {
                this.setState({isSave: false});
                this.props.openNotification(
                    T('st_management_apply_reason_is_not_null'),
                    'danger',
                );
            } else if (description.length > 200) {
                this.setState({isSave: false});
                this.props.openNotification(
                    T('st_management_apply_reason_length_not_more_than_200'),
                    'danger',
                );
            } else {
                this.saveApplyChange(params);
            }
        }
    };

    saveApplyChange = (params) => {
        this.props
            .saveStApplyChange(params)
            .then((res) => {
                if (res && res.status === 'success') {
                    this.setState({loading: false, isSave: false});
                    this.props.history.push(`/stManagementList`, {
                        type: 'list',
                        currentQueryKey: this.props.location.state.queryKey,
                    });
                    this.props.openNotification(
                        T('st_management_have_received_apply'),
                        'success',
                        {
                            testid: 'change-request-success',
                        },
                    );
                }
            })
            .catch((res) => {
                if (res && res.status) {
                    if (res.status === 'Invalid_Ship_To') {
                        this.setState({isSave: false});
                        this.props.openNotification(
                            T('b2b_management_platform_shipto_duplicate'),
                            'danger',
                        );
                    } else if (res.status === 'Applying_Ship_To') {
                        this.setState({isSave: false});
                        this.props.openNotification(
                            T('st_management_not_repeat_apply_change'),
                            'danger',
                        );
                    }
                }
            });
    };

    goBack = () => {
        if (typeof this.props.location.state.noScOrderFlag !== 'undefined') {
            if (typeof this.props.location.state.noScOrderFlag) {
                if (typeof this.props.location.state.stItem !== 'undefined') {
                    this.props.history.push(`/demoSiteOrderList`, {
                        shipToNumber: this.props.location.state.stItem.shipTo,
                        customerEmail: this.props.location.state.currentEmail,
                    });
                }
            }
        } else {
            this.props.history.push(`/stManagementList`, {
                type: 'list',
                currentQueryKey: this.props.location.state.queryKey,
            });
        }
    };

    handleTransportMethodChange = (item) =>
        this.setState({transportMethodId: item.id});
    handleSelectApplySpChange = (item) =>
        this.setState({applySupplyCenterId: item.id});

    render() {
        const {
            stObj,
            applySupplyCenterId,
            transportMethodId,
            supplyCenterDataList,
            transportMethodList,
            description,
            isSave,
            remarkNum,
        } = this.state;
        let lang = loadLanguage();
        const type = this.props.location.state.type;

        return (
            <div className="st-apply-change-save">
                <Grid
                    className="container-max-width is-fixed apply-change-to-head"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="back-icon" item xs={3}>
                        <IconButton
                            color="inherit"
                            onClick={() => this.goBack()}>
                            <ArrowBackIos />
                        </IconButton>
                    </Grid>

                    <Grid
                        className={util.getClassName({
                            'page-title': true && lang !== 'EN',
                            'en-page-title': true && lang === 'EN',
                        })}
                        item
                        xs={9}>
                        <span>{T('st_management_apply_change')}</span>
                    </Grid>
                </Grid>
                <div className="content">
                    <section className="content-box b2b-management-basicselect">
                        <Grid
                            container
                            spacing={0}
                            justify={'center'}
                            className="transfer-to-container">
                            <Grid item xs={12} className="st-apply-content">
                                <label className="st-apply-change-info-left">
                                    {T('shipTo')}
                                </label>
                                <p className="st-apply-change-info-right">
                                    {stObj && stObj.shipTo}
                                </p>
                            </Grid>
                            <Grid item xs={12} className="st-apply-content">
                                <label className="st-apply-change-info-left label-width">
                                    {T('st_management_subject')}
                                </label>
                                <p className="st-apply-change-info-right content-width">
                                    {stObj && stObj.stAlphaName}
                                </p>
                            </Grid>
                            <Grid item xs={12} className="st-address-style">
                                <label className="st-apply-change-info-left label-width">
                                    {T('st_management_st_address')}
                                </label>
                                <p className="st-apply-change-info-right content-width apply-change-st-address">
                                    {stObj && stObj.stAddress
                                        ? stObj.stAddress
                                        : T('st_management_no')}
                                </p>
                            </Grid>
                            {stObj && stObj.actualCoveredSiteNum ? (
                                <Grid item xs={12} className="st-apply-content">
                                    <label className="st-apply-change-info-left">
                                        {T('st_management_current_sp')}
                                    </label>
                                    <p className="st-apply-change-info-right">
                                        {stObj && stObj.actualCoveredSiteName
                                            ? stObj.actualCoveredSiteName
                                            : T('st_management_no')}
                                    </p>
                                </Grid>
                            ) : null}
                            {stObj && stObj.actualCoveredSiteNum ? (
                                <Grid item xs={12} className="st-apply-content">
                                    <label className="required-label">*</label>
                                    <label className="st-apply-change-info-left">
                                        {T('st_management_apply_sp')}
                                    </label>
                                    <Select
                                        className="select"
                                        testid="st-change-request"
                                        value={applySupplyCenterId}
                                        placeholder={T(
                                            'st_management_please_select_apply_sp',
                                        )}
                                        data={supplyCenterDataList}
                                        displayKey="name"
                                        valueKey="id"
                                        onChange={
                                            this.handleSelectApplySpChange
                                        }
                                        options={{
                                            icon: {
                                                show: true,
                                                color: '#E82D38',
                                            },
                                        }}
                                    />
                                </Grid>
                            ) : null}
                            {stObj && stObj.actualCoveredSiteNum ? (
                                <Grid item xs={12} className="st-apply-content">
                                    <label className="required-label">*</label>
                                    <label className="st-apply-change-info-left">
                                        {T('st_management_transation_method')}
                                    </label>
                                    <Select
                                        className="select"
                                        testid="select-transport-method"
                                        value={transportMethodId}
                                        data={transportMethodList}
                                        displayKey="name"
                                        valueKey="id"
                                        onChange={
                                            this.handleTransportMethodChange
                                        }
                                        options={{
                                            icon: {
                                                show: true,
                                                color: '#E82D38',
                                            },
                                        }}
                                    />
                                </Grid>
                            ) : null}
                            <Grid
                                item
                                xs={12}
                                className="st-apply-change-reason">
                                <BasicTextArea
                                    type="text"
                                    title={'st_management_apply_reason'}
                                    testid="st-change-request-reason-input"
                                    inputValid={this.handleTextArea}
                                    defalutValue={description}
                                    clearInput={this.clearInput}
                                    value={description}
                                    maxlength={200}
                                    placeholder={T(
                                        'st_management_please_enter_apply_reason',
                                    )}
                                    required="true"
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                className="apply-reason-prompt-message">
                                ({remarkNum}/200)
                            </Grid>
                        </Grid>
                    </section>
                </div>

                <Grid
                    className="confirm-select"
                    container
                    spacing={0}
                    justify={'center'}>
                    <Grid item xs={5}>
                        <BasicButton
                            className={util.getClassName({
                                'btn-width': true && lang !== 'EN',
                                'en-btn-width': true && lang === 'EN',
                            })}
                            testid="st-change-request-submit"
                            type="primary"
                            disabled={!isSave ? false : true}
                            onClickOfSingleTap={this.confirmApply}>
                            <span>
                                {type == 'add'
                                    ? T('b2b_management_submit')
                                    : T('st_management_confirm_apply')}
                            </span>
                        </BasicButton>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host, localData, userCenter, stManagement, notification} = state;
    return {
        applySupplyCenterList: stManagement.applySupplyCenterList,
        transportMethodList: stManagement.transportMethodList,
        supplyCenterlist: host.supplyCenterlist,
        SCList: userCenter.SCList,
        skuVagueSearchData: host.skuVagueSearchData,
        supplyCenterAlllist: host.supplyCenterAlllist,
        msg: notification.msg,
        localData: localData,
    };
};

const mapDispatchToProps = {
    openNotification,
    queryShipToBySupplyCenterList,
    getTransportMethodList,
    saveStApplyChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(StApplyChange);
